import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useAppContext from 'flow/hooks/useAppContext';
import React, { useState } from 'react';
import BaseInput from 'flow/components/ui-components/BaseInput';
import BaseModal from 'flow/components/ui-components/BaseModal';
import ImagePicker from 'flow/pages/messages/ImagePicker';
import { createRoomSession, deleteRoomImage, setRoomImage, updateChatSession } from 'flow/actions/chat-actions';
import { fromJS } from 'immutable';
import { generatePath, useHistory } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import BaseTextArea from 'flow/components/ui-components/BaseTextArea';
import { roomTypes } from 'flow/pages/messages/MessageInput';
import useAutoFocus from 'flow/hooks/useAutoFocus';
import { getChatRoomAvatar } from 'flow/utils';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultValue = {
  attachment: null,
  title: '',
  description: '',
  imageSrc: ''
};
var ManagePublicRoomModal = function ManagePublicRoomModal(_ref) {
  var sessionKey = _ref.sessionKey,
    editRoom = _ref.editRoom;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var session = useAppSelector(function (state) {
    return state.chats.getIn(['sessions', sessionKey]);
  });
  var editValue = {
    attachment: null,
    imageSrc: session !== null && session !== void 0 && session.get('roomImageResource') ? getChatRoomAvatar(session === null || session === void 0 ? void 0 : session.get('roomImageResource')) : '',
    title: session === null || session === void 0 ? void 0 : session.get('name'),
    description: session === null || session === void 0 ? void 0 : session.get('roomDescription')
  };
  var _useState = useState(editRoom ? editValue : defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    roomContent = _useState2[0],
    setRoomContent = _useState2[1];
  var handleAttachment = function handleAttachment(attachment) {
    if (attachment) {
      var reader = new FileReader();
      reader.readAsDataURL(attachment);
      reader.onloadend = function () {
        setRoomContent(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            imageSrc: reader.result.toString(),
            attachment: attachment
          });
        });
      };
    }
  };
  var history = useHistory();
  var handleSubmit = function handleSubmit() {
    if (editRoom) {
      var sessionDTO = fromJS({
        key: sessionKey,
        name: roomContent.title,
        roomDescription: roomContent.description,
        roomType: roomTypes["public"]
      });
      dispatch(updateChatSession(sessionKey, sessionDTO));
      if (roomContent.attachment) {
        dispatch(setRoomImage(sessionKey, roomContent.attachment));
      } else if (!roomContent.imageSrc && session !== null && session !== void 0 && session.get('roomImageResource')) {
        dispatch(deleteRoomImage(sessionKey));
      }
    } else {
      var _sessionDTO = fromJS({
        name: roomContent.title,
        roomDescription: roomContent.description,
        roomType: roomTypes["public"]
      });
      var onSuccess = function onSuccess(chatSessionKey) {
        return history.push(generatePath(routes['messages.id.settings'], {
          id: chatSessionKey
        }));
      };
      dispatch(createRoomSession(_sessionDTO, roomContent.attachment, onSuccess));
    }
  };
  var inputRef = useAutoFocus();
  return /*#__PURE__*/_jsx(BaseModal, {
    open: true,
    header: editRoom ? i18next.t('Tooltip.Nav.Title.Edit') : i18next.t('Chat.Public.Create.Title'),
    onSubmit: handleSubmit,
    disableSubmit: !roomContent.title,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-5",
      children: [/*#__PURE__*/_jsx(ImagePicker, {
        imageSrc: roomContent.imageSrc,
        removeAttachment: function removeAttachment() {
          return setRoomContent(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              imageSrc: '',
              attachment: null
            });
          });
        },
        addAttachment: function addAttachment(e) {
          var _e$target;
          handleAttachment((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0]);
          e.target.value = null;
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex w-full flex-col gap-y-1.5",
        children: [/*#__PURE__*/_jsx("label", {
          htmlFor: "title",
          className: "text-xs text-gray-800",
          children: i18next.t('Chat.Public.Create.Name.Title')
        }), /*#__PURE__*/_jsx(BaseInput, {
          onChange: function onChange(e) {
            var title = e.target.value;
            setRoomContent(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                title: title
              });
            });
          },
          id: "title",
          value: roomContent.title,
          ref: inputRef,
          maxLength: 32
        })]
      }), /*#__PURE__*/_jsx(BaseTextArea, {
        label: i18next.t('Chat.Public.Create.Description.Title'),
        value: roomContent.description,
        onChange: function onChange(e) {
          var _e$target2;
          var description = (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value;
          setRoomContent(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              description: description
            });
          });
        },
        maxLength: 255,
        id: "description"
      })]
    })
  });
};
export default ManagePublicRoomModal;